
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/api",
      function () {
        return require("private-next-pages/signature/api/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signature/api"])
      });
    }
  